<template>
  <div v-if="item">
    <component :is="item.model_type" :id="item.model_id" :ticket_id="item.id" />
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  components: {
    subscription: () => import("./EditSubscription"),
  },
  data: () => ({
    cardLink: "tickets",
    cardSetLink: "tickets",
    item: null,
    fields: [],
  }),
  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>